import { toast } from 'react-toastify';
import axios from '../../axios';

import {
   ADD_COMPANY,
   DELETE_COMPANY,
   GET_COMPANIES,
   UPDATE_COMPANY,
   GET_COMPANY_DETAILS,
   UPDATE_COMPANY_SETTING,
   GET_BUSINESS_TYPES,
   GET_COMPANY_DETAILS_GST,
   GET_COMPANY,
   SHARED_COMPANY,
   UPDATE_DYNAMIC_BARCODE,
   GET_MOBILE_BY_EMAIL,
} from '../types';

export const getCompanies = () => async (dispatch) => {
   try {
      const res = await axios.get('/company/all');
      if (res.data.code === 1) {
         dispatch({
            type: GET_COMPANIES,
            payload: res.data.data,
         });
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
      return res.data;
   } catch (err) {
      // console.error("Error fetching group IDs:", err);
      // if(err.response.data.errors[0].message){
      //   toast.error(err.response.data.errors[0].message);
      // }
   }
};

export const getCompanyById = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/company/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_COMPANY,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const addCompany = (props, data) => async (dispatch) => {
   try {
      const accessToken = JSON.parse(localStorage.getItem('authTokenCustomer'))?.access_token;
      const res = await axios.post('/company/add', data, {
         headers: {
            'Content-Type': 'multipart/form-data', // Make sure the request is sent as form data
            Authorization: `Bearer ${accessToken}`,
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: ADD_COMPANY, payload: res.data.data });
         localStorage.setItem('companyId', res.data.data.id);
         // Navigate to the new company's dashboard with its ID
         //  props(`/${res.data.data.id}/default`);
         props('/admin/default');
         // props("/auth/create-comp");

         setTimeout(() => {
            toast.success('Company add successful!');
         }, 1000);
      } else {
         // props('/auth/create-comp');
         // dispatch(setAlert(res.data.message, 'warning'));
         toast.error('Company add failed! Please try again.');
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res?.data?.message);
         }, 1000);
      }
   } catch (err) {
      // props('/auth/create-comp');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const activateCompany = (companyId) => async (dispatch) => {
   try {
      const res = await axios.post(`/company/active/${companyId}`);

      if (res.data.code === 1) {
         // Successfully activated the company, fetch the updated company list
         dispatch(getCompanies()); // Ensure company list is updated with active status changes
         toast.success('Company activated successfully!');
      } else {
         toast.error('Failed to activate company. Please try again.');
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error(err.response?.data?.message || err.message);
   }
};

export const addCompanyInUI = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/company/add', data, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: ADD_COMPANY, payload: res.data.data });
         localStorage.setItem('companyId', res.data.data.id);

         setTimeout(() => {
            toast.success('Company add successful!');
         }, 1000);
      } else if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.error(err);
      if (err.response?.data?.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateCompany = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/company/update`, formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_COMPANY, payload: res.data.data });

         setTimeout(() => {
            toast.success('Company updated successfully!');
         }, 1000);
      } else if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.error(err);
      if (err.response?.data?.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateCompanySetting = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/company/update/setting`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_COMPANY_SETTING, payload: res.data.data });

         setTimeout(() => {
            toast.success('Company Setting updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

// Delete Company
export const deleteCompany = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/company/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_COMPANY, payload: { id } });
         setTimeout(() => {
            toast.success('Company deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getCompanyDetailsByGst = (gst) => async (dispatch) => {
   try {
      const res = await axios.get(`/company/gst/${gst}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_COMPANY_DETAILS_GST, payload: res.data.data });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getBusinessTypes = () => async (dispatch) => {
   try {
      const res = await axios.get('/company/business-type');
      if (res.data.code === 1) {
         dispatch({ type: GET_BUSINESS_TYPES, payload: res.data.data });
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
   }
};

export const removeDetails = () => async (dispatch) => {
   dispatch({ type: GET_COMPANY_DETAILS_GST, payload: null });
};

export const sharedCompany = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/company/shareComp', data);

      if (res.data.code === 1) {
         dispatch({ type: SHARED_COMPANY, payload: res.data.data });
         setTimeout(() => {
            toast.success('Company Shared successful!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getmobilebyemail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/user/getMobileByEmail', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_MOBILE_BY_EMAIL, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateDynamicBarcode = (payload) => async (dispatch) => {
   try {
      const res = await axios.post(`/company/update/barcode`, payload); // Send payload in the request

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_DYNAMIC_BARCODE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Barcode configuration updated successfully!');
         }, 1000);
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
         toast.error(err.response.data.message);
      } else {
         toast.error('An error occurred while updating barcode configuration');
      }
   }
};
